import { getBusinessVertical, type BusinessVertical } from "@graftus/schema";
import { useProfile } from "@/context/ProfileContext";

/** The active business's vertical (GRA-83); "sales" when unset. */
export function useBusinessVertical(): BusinessVertical {
  const { businessProfile } = useProfile();
  return getBusinessVertical(businessProfile);
}

/** Grocery store: no CRM UI, team-only KPIs, report uploads. */
export function useIsDvhBusiness(): boolean {
  return useBusinessVertical() === "dvh";
}
